import { useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import { lmsStore, useLms } from "../lib/lms";
import { useSeo } from "../lib/seo";
import { PotHero } from "../components/lms/PotHero";
import { PickPanel, UsedTeams } from "../components/lms/PickPanel";
import { GameweekHistory, Standings } from "../components/lms/Standings";
import { AdminPanel } from "../components/lms/AdminPanel";
import { JoinPanel, MyStatus, WinnerScreen } from "../components/lms/LmsParts";
import { AdminLogin } from "../components/lms/AdminAccess";

export function LmsAdminLink() {
  const { compId = "", token = "" } = useParams();
  const navigate = useNavigate();
  useEffect(() => {
    lmsStore.save({ id: compId, name: "", admin: token });
    navigate(`/lms/${compId}`, { replace: true });
  }, [compId, token, navigate]);
  return null;
}

export default function LmsCompetition() {
  const { compId = "" } = useParams();
  const { comp, setComp, error, load, live } = useLms(compId);
  useSeo({ title: comp ? `${comp.name} | Last Man Standing | DITHER` : "Last Man Standing | DITHER", description: "Premier League Last Man Standing on DITHER.", noindex: true });
  useEffect(() => { if (comp && (comp.me || comp.is_admin)) lmsStore.save({ id: comp.id, name: comp.name }); }, [comp]);

  if (error) return <div className="mx-auto max-w-xl p-6 text-center font-bold" data-testid="lms-error">{error} <Link className="underline" to="/lms">Start a new one</Link></div>;
  if (!comp) return <div className="mx-auto max-w-5xl p-6 text-center font-comic text-xl" data-testid="lms-loading">Warming up…</div>;

  return (
    <div className="mx-auto max-w-5xl space-y-2 px-2 py-3 sm:space-y-3 sm:px-3" data-testid="lms-competition-page">
      <div className="flex items-center justify-between gap-2">
        <Link to="/lms" className="inline-flex items-center gap-1 text-sm font-extrabold uppercase tracking-wide hover:underline" data-testid="lms-back-link"><ChevronLeft className="h-4 w-4" strokeWidth={3} /> Last Man Standing</Link>
        {!comp.is_admin && <AdminLogin comp={comp} onDone={load} />}
      </div>
      {comp.status === "finished" && <WinnerScreen comp={comp} />}
      <PotHero comp={comp} live={live} />
      {comp.is_admin && <AdminPanel comp={comp} onChange={setComp} />}
      {!comp.me && comp.status === "active" && <JoinPanel comp={comp} onJoined={load} />}
      {comp.me && comp.status === "active" && <MyStatus comp={comp} />}
      {comp.me?.alive && comp.status === "active" && comp.window === "open" && <PickPanel comp={comp} onChange={setComp} />}
      {comp.me && !(comp.me.alive && comp.window === "open" && comp.status === "active") && (
        <div className="rounded-[18px] border-[3px] border-[#0B1F33] bg-white px-3 py-1 pb-3 shadow-[0_4px_0_#0B1F33]"><UsedTeams teams={comp.me.used_teams} /></div>
      )}
      <Standings comp={comp} onChange={setComp} />
      <GameweekHistory comp={comp} />
    </div>
  );
}
